import React from 'react'
import PropTypes from 'prop-types'
import { useFieldName } from '@morningtrain/react-fields'
import { useEnvValue } from '@morningtrain/react-helpers'

function EnvField ({ name, path }) {
  const fieldName = useFieldName(name)
  const [value] = useEnvValue(path)

  return (
    <input
      name={fieldName}
      type='hidden'
      value={value}
    />
  )
}

EnvField.propTypes = {
  name: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired
}

export default EnvField
